import React from 'react'
import { Popover } from 'common/Popover'
import styles from './LinkToolbar.scss'
import { addLinkToEditorState } from 'lib/draftUtils'

const ENTER_KEY = 13
const ESC_KEY = 27

export class LinkToolbar extends React.Component {
  constructor (props) {
    super(props)
    this.state = { url: '' }
  }

  componentDidMount () {
    this.focusInput()
  }

  setInputRef = (elem) => {
    this._input = elem
  }

  focusInput = () => {
    if (this._input) {
      this._input.focus()
    }
  }

  onKeyUp = (e) => {
    const { editorState, onChange, onDismiss } = this.props
    if (e.keyCode === ENTER_KEY) {
      e.stopPropagation()
      const { url } = this.state
      const normalizedUrl = normalizeUrl(url)
      const withLink = addLinkToEditorState(editorState, normalizedUrl)
      onChange(withLink, onDismiss)
    }
    if (e.keyCode === ESC_KEY) {
      onDismiss()
    }
  }

  onChange = (e) => {
    this.setState({ url: e.target.value })
  }

  render () {
    const { style, placeholderUrl } = this.props
    const { url } = this.state
    const styleOverrides = {
      ...style,
      width: 200
    }
    return (
      <Popover mountOnBody style={styleOverrides}>
        <li className={styles.urlLi}>
          <input type='text'
            value={url}
            className={styles.urlInput}
            placeholder={placeholderUrl}
            onKeyUp={this.onKeyUp}
            onChange={this.onChange}
            ref={this.setInputRef}
            onBlur={this.props.onDismiss} />
        </li>
      </Popover>
    )
  }
}

const normalizeUrl = (url) => {
  if (url.match(/^http/i)) {
    return url
  } else {
    return `http://${url}`
  }
}
